// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./reset.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #fff;
  z-index: 999;
}
.header .inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}
.header .inner .logo img {
  width: 310px;
}
.header .inner .gnb {
  height: 100%;
}
.header .inner .gnb .anchor_list {
  height: 100%;
}
.header .inner .gnb ul {
  display: flex;
  gap: 80px;
  height: 100%;
}
.header .inner .gnb ul li {
  height: 100%;
}
.header .inner .gnb ul li a {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 20px;
  cursor: pointer;
  color: #aeaeae;
  transition: all ease-out 0.25s;
}
.header .inner .gnb ul li a:hover, .header .inner .gnb ul li a.active {
  overflow: hidden;
  color: #222;
  font-weight: 700;
}

.footer {
  display: flex;
  justify-content: center;
  background-color: #0f1821;
}
.footer .inner {
  display: flex;
  justify-content: space-between;
  padding: 50px;
  color: #ccc;
}
.footer .inner .footer_head .logo img {
  height: 18px;
}
.footer .inner .footer_head .footer_content {
  margin-top: 28px;
  font-size: 14px;
  color: #606a77;
}
.footer .inner .footer_head .footer_content .address {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.footer .inner .footer_head .footer_content .address li {
  position: relative;
  display: flex;
  align-items: center;
}
.footer .inner .footer_head .footer_content .address li span {
  display: flex;
  align-items: center;
  gap: 8px;
}
.footer .inner .footer_head .footer_content .address li span strong {
  color: #9ea0a4;
  font-weight: 400;
}
.footer .inner .footer_head .footer_content .address li span.ceo strong {
  font-weight: 700;
  color: #9ea0a4;
}
.footer .inner .footer_head .footer_content .address li span + span::before {
  content: "";
  display: block;
  width: 1px;
  height: 10px;
  margin: 0 4px 0 12px;
  background-color: #555b64;
}
.footer .inner .footer_head .footer_content .copyright {
  margin-top: 20px;
}
.footer .inner .footer_body {
  font-size: 15px;
  color: #606a77;
}
.footer .inner .footer_body ul {
  display: flex;
  align-items: center;
}
.footer .inner .footer_body ul li {
  display: flex;
  align-items: center;
}
.footer .inner .footer_body ul li + li::before {
  content: "";
  display: block;
  width: 1px;
  height: 12px;
  margin: 0 12px;
  background-color: #555b64;
}
.footer .inner .footer_body ul li:hover, .footer .inner .footer_body ul li:focus {
  color: #9ea0a4;
}

.scroll_top_area {
  position: fixed;
  bottom: 40px;
  right: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #333;
  cursor: pointer;
}

.inner {
  position: relative;
  justify-content: flex-start;
  max-width: 1160px;
  width: 100%;
  height: 100%;
}

.m_show {
  display: none !important;
}

.m_hide {
  display: inline !important;
}

.section_area .section_intro {
  display: flex;
  justify-content: center;
  height: 912px;
  margin-top: 80px;
  background-color: #d9dbde;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.section_area .section_intro .inner {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.section_area .section_intro .section_head h1 {
  font-size: 68px;
  font-weight: 800;
  line-height: 90px;
}
.section_area .section_intro .section_head p {
  margin-top: 33px;
  font-size: 22px;
  font-weight: 500;
  line-height: 34px;
}
.section_area .section_intro .section_body .character {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  width: 626px;
}
.section_area .section_description {
  display: flex;
  justify-content: center;
}
.section_area .section_description .section_head {
  width: 100%;
  margin: 140px 0;
}
.section_area .section_description .section_head > div {
  display: flex;
  width: 100%;
}
.section_area .section_description .section_head h1 {
  font-size: 76px;
  font-weight: 700;
  line-height: 100px;
  letter-spacing: -0.02em;
}
.section_area .section_description .section_head p {
  width: 72%;
  margin-top: 84px;
  margin-left: auto;
  font-size: 44px;
  font-weight: 600;
  line-height: 64px;
  letter-spacing: -0.02em;
}
.section_area .section_service {
  display: flex;
  justify-content: center;
  padding: 200px 0;
  color: #fff;
  background-color: #0f1215;
}
.section_area .section_service .inner {
  flex-direction: column;
  align-items: flex-start;
}
.section_area .section_service .inner .section_head .title_tag {
  display: block;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
}
.section_area .section_service .inner .section_head h1 {
  font-size: 52px;
  font-weight: 700;
  line-height: 62px;
  letter-spacing: 0em;
}
.section_area .section_service .inner .section_head ul {
  margin-top: 26px;
}
.section_area .section_service .inner .section_head ul li {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #8d9fb0;
}
.section_area .section_service .inner .section_body {
  width: 100%;
  margin-top: 80px;
}
.section_area .section_service .inner .section_body .service_grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 30px;
  grid-row-gap: 30px;
}
.section_area .section_service .inner .section_body .service_grid > div {
  padding: 60px 50px 40px;
  border-radius: 28px;
  overflow: hidden;
}
.section_area .section_service .inner .section_body .service_grid > div:nth-child(1) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(270deg, #c229cb 0%, #5072dc 100%);
  grid-area: 1/1/2/3;
}
.section_area .section_service .inner .section_body .service_grid > div:nth-child(1) h2 {
  font-size: 36px;
  font-weight: 700;
  line-height: 44px;
}
.section_area .section_service .inner .section_body .service_grid > div:nth-child(1) p {
  margin-top: 16px;
  font-size: 20px;
  font-weight: 700;
  line-height: 34px;
  opacity: 0.8;
}
.section_area .section_service .inner .section_body .service_grid > div:nth-child(1) span {
  display: block;
  margin-top: 74px;
  font-size: 20px;
  font-weight: 500;
  line-height: 34px;
  opacity: 0.5;
}
.section_area .section_service .inner .section_body .service_grid > div:nth-child(2) {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #3f00f4;
  grid-area: 1/3/2/4;
}
.section_area .section_service .inner .section_body .service_grid > div:nth-child(3) {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #138dff;
  grid-area: 2/1/3/2;
}
.section_area .section_service .inner .section_body .service_grid > div:nth-child(4) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(90deg, #3cd8b4 0%, #8244ee 100%);
  grid-area: 2/2/3/4;
}
.section_area .section_service .inner .section_body .service_grid > div:nth-child(4) .grid_head {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.section_area .section_service .inner .section_body .service_grid > div:nth-child(4) .grid_head h2 {
  font-size: 36px;
  font-weight: 700;
  line-height: 44px;
}
.section_area .section_service .inner .section_body .service_grid > div:nth-child(4) .grid_head ul {
  display: flex;
  gap: 38px;
}
.section_area .section_service .inner .section_body .service_grid > div:nth-child(4) .grid_head ul li h3 {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.05em;
}
.section_area .section_service .inner .section_body .service_grid > div:nth-child(4) .grid_head ul li p {
  margin-top: 6px;
  font-size: 32px;
  font-weight: 600;
  letter-spacing: -0.05em;
}
.section_area .section_service .inner .section_body .service_grid > div:nth-child(4) .grid_head ul li p span {
  font-weight: 800;
}
.section_area .section_service .inner .section_body .service_grid > div:nth-child(4) .grid_body {
  margin-bottom: -64px;
}
.section_area .section_solution {
  display: flex;
  justify-content: center;
  padding: 200px 0;
}
.section_area .section_solution .section_head .title_tag {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #027dff;
  margin-bottom: 10px;
}
.section_area .section_solution .section_head h1 {
  font-size: 52px;
  font-weight: 700;
  line-height: 62px;
}
.section_area .section_solution .section_head p {
  margin-top: 26px;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
}
.section_area .section_solution .section_body {
  margin-top: 50px;
}
.section_area .section_solution .section_body .solution_banner {
  display: flex;
  align-items: flex-end;
  height: 624px;
  padding: 90px 60px;
  color: #fff;
  background-size: contain;
  background-repeat: no-repeat;
}
.section_area .section_solution .section_body .solution_banner h1 {
  font-size: 46px;
  line-height: 68px;
}
.section_area .section_solution .section_body .solution_banner_desc {
  position: relative;
  display: flex;
  align-items: center;
  height: 399px;
  margin-top: 26px;
  padding: 69px 60px;
  border-radius: 40px;
  background-color: #f3f4f8;
  background-size: contain;
  background-repeat: no-repeat;
  overflow: hidden;
}
.section_area .section_solution .section_body .solution_banner_desc h1 {
  font-size: 34px;
  font-weight: 700;
  line-height: 53px;
  color: #2f4459;
}
.section_area .section_solution .section_body .solution_banner_desc h1 p {
  color: #138dff;
}
.section_area .section_solution .section_body .solution_banner_desc h1 p span {
  font-weight: 400;
}
.section_area .section_solution .section_body .solution_banner_desc img {
  position: absolute;
  top: 0;
  right: 0;
  width: 518px;
}
.section_area .section_solution + .banner {
  text-align: center;
}
.section_area .section_card_list {
  display: flex;
  justify-content: center;
  padding: 240px 0;
  background-color: #f5f6f9;
}
.section_area .section_card_list .section_head .title_tag {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #8b93b5;
  margin-bottom: 10px;
}
.section_area .section_card_list .section_head h1 {
  font-size: 52px;
  font-weight: 700;
  line-height: 62px;
  color: #0f1e2d;
}
.section_area .section_card_list .section_head h1 span {
  color: #0d96ff;
}
.section_area .section_card_list .section_head p {
  margin-top: 26px;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  color: #0f1e2d;
}
.section_area .section_card_list .section_head p span {
  color: #9ca4ac;
}
.section_area .section_card_list .section_body {
  margin-top: 70px;
}
.section_area .section_card_list .section_body .card_list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 0px;
}
.section_area .section_card_list .section_body .card_list > li {
  flex: 1 1;
}
.section_area .section_card_list .section_body .card_list > li .card_cont {
  display: flex;
  flex-direction: column;
  height: 343px;
  padding: 44px 30px 30px;
  border-radius: 30px;
  background-color: #e6eaf3;
}
.section_area .section_card_list .section_body .card_list > li .card_cont h2 {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: -0.05em;
}
.section_area .section_card_list .section_body .card_list > li .card_cont h2 span {
  display: flex;
  align-items: center;
}
.section_area .section_card_list .section_body .card_list > li .card_cont h2 span + span::before {
  content: "";
  display: block;
  width: 7px;
  height: 7px;
  margin: 0 8px;
  border-radius: 50%;
  background-color: #122335;
}
.section_area .section_card_list .section_body .card_list > li .card_cont ul {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 20px;
  font-size: 17px;
  font-weight: 500;
}
.section_area .section_card_list .section_body .card_list > li .card_cont p {
  margin-top: auto;
  margin-left: auto;
}
.section_area .section_card_list .section_body .card_list > li .card_desc {
  margin-top: 26px;
  padding: 0 3px;
  font-size: 20px;
  font-weight: 600;
  line-height: 31px;
  letter-spacing: -0.05em;
}
.section_area .section_partner {
  display: flex;
  justify-content: center;
  padding: 200px 0;
}
.section_area .section_partner .inner .section_head h1 {
  font-size: 52px;
  font-weight: 700;
  line-height: 66px;
  color: #0f1e2d;
  text-align: center;
}
.section_area .section_partner .inner .section_head .partner_count {
  margin: 70px auto 115px;
}
.section_area .section_partner .inner .section_head .partner_count ul {
  display: flex;
  justify-content: center;
  gap: 100px;
}
.section_area .section_partner .inner .section_head .partner_count ul li {
  text-align: center;
}
.section_area .section_partner .inner .section_head .partner_count ul li p {
  font-size: 56px;
  font-weight: 600;
  letter-spacing: -0.05em;
}
.section_area .section_partner .inner .section_head .partner_count ul li p strong {
  font-weight: 800;
}
.section_area .section_partner .inner .section_head .partner_count ul li em {
  display: block;
  margin-top: 14px;
  font-size: 18px;
  font-weight: 700;
  color: #0d96ff;
}
.section_area .section_partner .inner .section_body {
  margin-top: 70px;
}
.section_area .section_company {
  display: flex;
  background-color: #f3f4f8;
}
.section_area .section_company .section_head {
  text-align: right;
}
.section_area .section_company .section_body {
  flex: 1 1;
  display: flex;
  align-items: flex-end;
  padding: 103px 90px;
  background-color: #f3f4f8;
}
.section_area .section_company .section_body ul {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.section_area .section_company .section_body ul dl {
  display: flex;
  gap: 30px;
  font-size: 19px;
  color: #262626;
  letter-spacing: -0.05em;
}
.section_area .section_company .section_body ul dl dt {
  min-width: 83px;
  font-weight: 700;
}
.section_area .section_company .section_body ul dl dd {
  font-weight: 500;
}
.section_area .section_company .section_body .company_logo {
  max-width: 373px;
  padding-bottom: 8px;
}

@media (max-width: 1080px) {
  .inner {
    padding: 0 18px;
  }
  .m_show {
    display: inline !important;
  }
  .m_hide {
    display: none !important;
  }
  .header {
    position: sticky;
    top: -56px;
  }
  .header .inner {
    flex-direction: column;
    align-items: flex-start;
    height: auto;
  }
  .header .inner .logo {
    padding: 11px 0;
  }
  .header .inner .logo img {
    width: 120px;
  }
  .header .inner .gnb {
    width: 100%;
  }
  .header .inner .gnb ul {
    justify-content: space-between;
    gap: unset;
  }
  .header .inner .gnb ul li a {
    padding: 14px 0;
    font-size: 16px;
    letter-spacing: -0.05em;
  }
  .footer .inner {
    padding: 40px 20px;
  }
  .footer .inner .footer_content .address li:nth-child(2) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .footer .inner .footer_content .address li:nth-child(2) span + span::before {
    content: "";
    display: none;
  }
  .footer .inner .footer_content .copyright {
    font-size: 13px;
  }
  .section_area .section_intro {
    height: 340px;
    margin-top: 0px;
    background-position: right -125px bottom -30px;
  }
  .section_area .section_intro .inner {
    align-items: flex-start;
    padding-top: 44px;
  }
  .section_area .section_intro .section_head h1 {
    font-size: 26px;
    line-height: 36px;
  }
  .section_area .section_intro .section_head p {
    margin-top: 15px;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.05em;
  }
  .section_area .section_description .section_head {
    margin: 60px 0;
  }
  .section_area .section_description .section_head h1 {
    font-size: 26px;
    line-height: 34px;
  }
  .section_area .section_description .section_head p {
    margin-top: 20px;
    font-size: 16px;
    line-height: 24px;
  }
  .section_area .section_service {
    padding: 80px 0;
  }
  .section_area .section_service .inner .section_head .title_tag {
    font-size: 16px;
  }
  .section_area .section_service .inner .section_head h1 {
    font-size: 26px;
    line-height: 34px;
  }
  .section_area .section_service .inner .section_head ul {
    margin-top: 12px;
  }
  .section_area .section_service .inner .section_head ul li {
    font-size: 14px;
    line-height: 20px;
  }
  .section_area .section_service .inner .section_body {
    margin-top: 38px;
  }
  .section_area .section_service .inner .section_body .service_grid {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-column-gap: 10px;
    grid-row-gap: 20px;
  }
  .section_area .section_service .inner .section_body .service_grid > div {
    padding: 20px 16px;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(1) {
    position: relative;
    grid-area: 1/1/2/3;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(1) h2 {
    font-size: 20px;
    line-height: 28px;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(1) p {
    margin-top: 10px;
    font-size: 14px;
    line-height: 17px;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(1) span {
    margin-top: 39px;
    font-size: 13px;
    line-height: 16px;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(1) img {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    display: block;
    width: 111px;
    object-fit: contain;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(2) {
    grid-area: 2/1/3/2;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(2) img {
    width: 105px;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(3) {
    grid-area: 2/2/3/3;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(3) img {
    width: 130px;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(4) {
    position: relative;
    grid-area: 3/1/4/3;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(4) .grid_head h2 {
    font-size: 20px;
    line-height: 28px;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(4) .grid_head ul {
    gap: 12px;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(4) .grid_head ul li h3 {
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(4) .grid_head ul li p {
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0;
  }
  .section_area .section_service .inner .section_body .service_grid > div:nth-child(4) .grid_body img {
    position: absolute;
    bottom: 0;
    right: 8px;
    display: block;
    width: 106px;
  }
  .section_area .section_solution {
    padding: 60px 0;
  }
  .section_area .section_solution .section_head .title_tag {
    font-size: 16px;
  }
  .section_area .section_solution .section_head h1 {
    font-size: 26px;
    line-height: 34px;
  }
  .section_area .section_solution .section_head p {
    margin-top: 12px;
    font-size: 14px;
    line-height: 20px;
  }
  .section_area .section_solution .section_body .solution_banner {
    height: 240px;
    padding: 20px 30px;
    border-radius: 18px;
    background-size: cover;
    background-position: center;
    overflow: hidden;
  }
  .section_area .section_solution .section_body .solution_banner h1 {
    font-size: 18px;
    line-height: 26px;
  }
  .section_area .section_solution .section_body .solution_banner_desc {
    height: auto;
    margin-top: 16px;
    padding: 22px 20px;
    border-radius: 18px;
  }
  .section_area .section_solution .section_body .solution_banner_desc h1 {
    position: relative;
    padding-top: 236px;
    font-size: 18px;
    line-height: 28px;
    z-index: 1;
  }
  .section_area .section_solution .section_body .solution_banner_desc p {
    display: inline;
  }
  .section_area .section_solution + .banner {
    height: 165px;
  }
  .section_area .section_solution + .banner img {
    height: 100%;
    object-fit: cover;
  }
  .section_area .section_card_list {
    padding: 60px 0;
  }
  .section_area .section_card_list .section_head .title_tag {
    font-size: 16px;
  }
  .section_area .section_card_list .section_head h1 {
    font-size: 26px;
    line-height: 36px;
  }
  .section_area .section_card_list .section_head p {
    margin-top: 12px;
    font-size: 14px;
    line-height: 22px;
  }
  .section_area .section_card_list .section_body {
    margin-top: 30px;
  }
  .section_area .section_card_list .section_body .card_list {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  .section_area .section_card_list .section_body .card_list > li .card_cont {
    display: grid;
    grid-template-columns: 4fr 3fr;
    grid-template-rows: repeat(2, 1fr);
    height: 130px;
    padding: 20px 30px;
  }
  .section_area .section_card_list .section_body .card_list > li .card_cont h2 {
    grid-area: 1/1/2/2;
    font-size: 16px;
  }
  .section_area .section_card_list .section_body .card_list > li .card_cont ul {
    grid-area: 2/1/3/2;
    gap: 5px;
    margin-top: 0;
    font-size: 13px;
    line-height: 15px;
  }
  .section_area .section_card_list .section_body .card_list > li .card_cont p {
    grid-area: 1/2/3/3;
    margin: auto;
  }
  .section_area .section_card_list .section_body .card_list > li .card_cont p img {
    width: 80px;
  }
  .section_area .section_card_list .section_body .card_list > li .card_desc {
    margin-top: 14px;
    font-size: 14px;
    line-height: 22px;
  }
  .section_area .section_partner {
    padding: 60px 0;
  }
  .section_area .section_partner .inner .section_head h1 {
    font-size: 26px;
    line-height: 36px;
  }
  .section_area .section_partner .inner .section_body {
    margin-top: 40px;
  }
  .section_area .section_partner .inner .section_body .img_partner {
    padding: 0 20px;
  }
  .section_area .section_company {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/pages.scss"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;AADF;AAGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AADJ;AAIM;EACE,YAAA;AAFR;AAMI;EACE,YAAA;AAJN;AAMM;EACE,YAAA;AAJR;AAOM;EACE,aAAA;EACA,SAAA;EACA,YAAA;AALR;AAOQ;EACE,YAAA;AALV;AAOU;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EAEA,eAAA;EACA,cAAA;EACA,8BAAA;AANZ;AAQY;EAEE,gBAAA;EACA,WAAA;EACA,gBAAA;AAPd;;AAuCA;EACE,aAAA;EACA,uBAAA;EACA,yBAAA;AApCF;AAsCE;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;AApCJ;AAwCQ;EACE,YAAA;AAtCV;AA0CM;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAxCR;AA0CQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAxCV;AA0CU;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAxCZ;AA0CY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAxCd;AA0Cc;EACE,cAAA;EACA,gBAAA;AAxChB;AA4CgB;EACE,gBAAA;EACA,cAAA;AA1ClB;AA8CY;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;AA5Cd;AAiDQ;EACE,gBAAA;AA/CV;AAoDI;EACE,eAAA;EACA,cAAA;AAlDN;AAoDM;EACE,aAAA;EACA,mBAAA;AAlDR;AAmDQ;EACE,aAAA;EACA,mBAAA;AAjDV;AAkDU;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;AAhDZ;AAmDU;EAEE,cAAA;AAlDZ;;AA2DA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAxDF;;AA2DA;EACE,kBAAA;EACA,2BAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AAxDF;;AA2DA;EACE,wBAAA;AAxDF;;AA0DA;EACE,0BAAA;AAvDF;;AA6DE;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AA1DJ;AA4DI;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AA1DN;AA8DM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AA5DR;AA8DM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA5DR;AAgEM;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;AA9DR;AAoEE;EACE,aAAA;EACA,uBAAA;AAlEJ;AAoEI;EACE,WAAA;EACA,eAAA;AAlEN;AAoEM;EACE,aAAA;EACA,WAAA;AAlER;AAoEM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AAlER;AAqEM;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAnER;AAwEE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;AAtEJ;AAwEI;EACE,sBAAA;EACA,uBAAA;AAtEN;AAyEQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAvEV;AAyEQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAvEV;AAyEQ;EACE,gBAAA;AAvEV;AAyEU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAvEZ;AA4EM;EACE,WAAA;EACA,gBAAA;AA1ER;AA4EQ;EACE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;AA1EV;AA4EU;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AA1EZ;AA6EU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,6DAAA;EACA,kBAAA;AA3EZ;AA6EY;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AA3Ed;AA8EY;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AA5Ed;AA8EY;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AA5Ed;AA+EU;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AA7EZ;AA+EU;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AA7EZ;AA+EU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4DAAA;EACA,kBAAA;AA7EZ;AA+EY;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AA7Ed;AA+Ec;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AA7EhB;AAgFc;EACE,aAAA;EACA,SAAA;AA9EhB;AAiFkB;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AA/EpB;AAiFkB;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AA/EpB;AAiFoB;EACE,gBAAA;AA/EtB;AAsFY;EACE,oBAAA;AApFd;AA6FE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AA3FJ;AA8FM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA5FR;AA8FM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AA5FR;AA8FM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA5FR;AAgGI;EACE,gBAAA;AA9FN;AAgGM;EACE,aAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,4BAAA;AA9FR;AAgGQ;EACE,eAAA;EACA,iBAAA;AA9FV;AAkGM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,4BAAA;EACA,gBAAA;AAhGR;AAkGQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAhGV;AAkGU;EACE,cAAA;AAhGZ;AAkGY;EACE,gBAAA;AAhGd;AAqGQ;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;AAnGV;AAwGI;EACE,kBAAA;AAtGN;AA2GE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;AAzGJ;AA4GM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA1GR;AA4GM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA1GR;AA4GQ;EACE,cAAA;AA1GV;AA6GM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA3GR;AA6GQ;EACE,cAAA;AA3GV;AA+GI;EACE,gBAAA;AA7GN;AA+GM;EACE,aAAA;EACA,qCAAA;EACA,uBAAA;EACA,qBAAA;EACA,iBAAA;AA7GR;AA+GQ;EACE,SAAA;AA7GV;AA+GU;EACE,aAAA;EACA,sBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AA9GZ;AAgHY;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AA9Gd;AAgHc;EACE,aAAA;EACA,mBAAA;AA9GhB;AAgHc;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AA9GhB;AAkHY;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAhHd;AAmHY;EACE,gBAAA;EACA,iBAAA;AAjHd;AAqHU;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAnHZ;AA0HE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAxHJ;AA4HQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AA1HV;AA4HQ;EACE,uBAAA;AA1HV;AA2HU;EACE,aAAA;EACA,uBAAA;EACA,UAAA;AAzHZ;AA0HY;EACE,kBAAA;AAxHd;AA0Hc;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AAxHhB;AA0HgB;EACE,gBAAA;AAxHlB;AA4Hc;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA1HhB;AAiIM;EACE,gBAAA;AA/HR;AAoIE;EACE,aAAA;EACA,yBAAA;AAlIJ;AAoII;EACE,iBAAA;AAlIN;AAoII;EACE,SAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;AAlIN;AAoIM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAlIR;AAoIQ;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;AAlIV;AAoIU;EACE,eAAA;EACA,gBAAA;AAlIZ;AAqIU;EACE,gBAAA;AAnIZ;AAwIM;EACE,gBAAA;EACA,mBAAA;AAtIR;;AA4IA;EACE;IACE,eAAA;EAzIF;EA2IA;IACE,0BAAA;EAzIF;EA2IA;IACE,wBAAA;EAzIF;EA4IA;IACE,gBAAA;IACA,UAAA;EA1IF;EA4IE;IACE,sBAAA;IACA,uBAAA;IACA,YAAA;EA1IJ;EA2II;IACE,eAAA;EAzIN;EA0IM;IACE,YAAA;EAxIR;EA2II;IACE,WAAA;EAzIN;EA0IM;IACE,8BAAA;IACA,UAAA;EAxIR;EA2IU;IACE,eAAA;IACA,eAAA;IACA,uBAAA;EAzIZ;EAkJE;IACE,kBAAA;EAhJJ;EAoJQ;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EAlJV;EAoJU;IACE,WAAA;IACA,aAAA;EAlJZ;EAuJM;IACE,eAAA;EArJR;EA6JE;IACE,aAAA;IACA,eAAA;IACA,8CAAA;EA3JJ;EA6JI;IACE,uBAAA;IACA,iBAAA;EA3JN;EA8JM;IACE,eAAA;IACA,iBAAA;EA5JR;EA+JM;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,uBAAA;EA7JR;EAoKI;IACE,cAAA;EAlKN;EAoKM;IACE,eAAA;IACA,iBAAA;EAlKR;EAoKM;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EAlKR;EAwKE;IACE,eAAA;EAtKJ;EA0KQ;IACE,eAAA;EAxKV;EA0KQ;IACE,eAAA;IACA,iBAAA;EAxKV;EA0KQ;IACE,gBAAA;EAxKV;EAyKU;IACE,eAAA;IACA,iBAAA;EAvKZ;EA4KM;IACE,gBAAA;EA1KR;EA4KQ;IACE,qCAAA;IACA,kCAAA;IACA,qBAAA;IACA,kBAAA;EA1KV;EA4KU;IACE,kBAAA;EA1KZ;EA6KU;IACE,kBAAA;IACA,kBAAA;EA3KZ;EA6KY;IACE,eAAA;IACA,iBAAA;EA3Kd;EA6KY;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EA3Kd;EA6KY;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EA3Kd;EA8KY;IACE,kBAAA;IACA,QAAA;IACA,WAAA;IACA,2BAAA;IACA,cAAA;IACA,YAAA;IACA,mBAAA;EA5Kd;EA+KU;IACE,kBAAA;EA7KZ;EA8KY;IACE,YAAA;EA5Kd;EA+KU;IACE,kBAAA;EA7KZ;EA8KY;IACE,YAAA;EA5Kd;EA+KU;IACE,kBAAA;IACA,kBAAA;EA7KZ;EAgLc;IACE,eAAA;IACA,iBAAA;EA9KhB;EAiLc;IACE,SAAA;EA/KhB;EAiLkB;IACE,eAAA;IACA,iBAAA;IACA,iBAAA;EA/KpB;EAiLkB;IACE,eAAA;IACA,iBAAA;IACA,iBAAA;EA/KpB;EAsLc;IACE,kBAAA;IACA,SAAA;IACA,UAAA;IACA,cAAA;IACA,YAAA;EApLhB;EA8LE;IACE,eAAA;EA5LJ;EA+LM;IACE,eAAA;EA7LR;EA+LM;IACE,eAAA;IACA,iBAAA;EA7LR;EA+LM;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EA7LR;EAkMM;IACE,aAAA;IACA,kBAAA;IACA,mBAAA;IACA,sBAAA;IACA,2BAAA;IACA,gBAAA;EAhMR;EAkMQ;IACE,eAAA;IACA,iBAAA;EAhMV;EAoMM;IACE,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,mBAAA;EAlMR;EAoMQ;IACE,kBAAA;IACA,kBAAA;IACA,eAAA;IACA,iBAAA;IACA,UAAA;EAlMV;EAqMQ;IACE,eAAA;EAnMV;EAwMI;IACE,aAAA;EAtMN;EAuMM;IACE,YAAA;IACA,iBAAA;EArMR;EA2ME;IACE,eAAA;EAzMJ;EA4MM;IACE,eAAA;EA1MR;EA6MM;IACE,eAAA;IACA,iBAAA;EA3MR;EA8MM;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EA5MR;EA+MI;IACE,gBAAA;EA7MN;EA+MM;IACE,aAAA;IACA,sBAAA;IACA,SAAA;EA7MR;EAgNU;IACE,aAAA;IACA,8BAAA;IACA,kCAAA;IACA,aAAA;IACA,kBAAA;EA9MZ;EAgNY;IACE,kBAAA;IACA,eAAA;EA9Md;EAgNY;IACE,kBAAA;IACA,QAAA;IACA,aAAA;IACA,eAAA;IACA,iBAAA;EA9Md;EAgNY;IACE,kBAAA;IACA,YAAA;EA9Md;EAgNc;IACE,WAAA;EA9MhB;EAmNU;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EAjNZ;EAwNE;IACE,eAAA;EAtNJ;EA0NQ;IACE,eAAA;IACA,iBAAA;EAxNV;EA4NM;IACE,gBAAA;EA1NR;EA4NQ;IACE,eAAA;EA1NV;EA+NE;IACE,aAAA;EA7NJ;AACF","sourcesContent":["@import url(\"reset.scss\");\n\n// Header\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  background-color: #fff;\n  z-index: 999;\n\n  .inner {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 80px;\n\n    .logo {\n      img {\n        width: 310px;\n      }\n    }\n\n    .gnb {\n      height: 100%;\n\n      .anchor_list {\n        height: 100%;\n      }\n\n      ul {\n        display: flex;\n        gap: 80px;\n        height: 100%;\n\n        li {\n          height: 100%;\n\n          a {\n            position: relative;\n            display: flex;\n            align-items: center;\n            height: 100%;\n            font-size: 20px;\n            // letter-spacing: -0.05em;\n            cursor: pointer;\n            color: #aeaeae;\n            transition: all ease-out 0.25s;\n\n            &:hover,\n            &.active {\n              overflow: hidden;\n              color: #222;\n              font-weight: 700;\n\n              // @keyframes line {\n              //   0% {\n              //     transform: translateX(-100%);\n              //   }\n              //   100% {\n              //     transform: translateX(0);\n              //   }\n              // }\n              // &::after {\n              //   content: \"\";\n              //   position: absolute;\n              //   left: 0;\n              //   bottom: 0;\n              //   display: block;\n              //   width: 100%;\n              //   height: 2px;\n              //   background-color: #000;\n              //   animation: line;\n              //   animation-timing-function: linear;\n              //   animation-duration: 0.2s;\n              // }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// Footer\n.footer {\n  display: flex;\n  justify-content: center;\n  background-color: #0f1821;\n\n  .inner {\n    display: flex;\n    justify-content: space-between;\n    padding: 50px;\n    color: #ccc;\n\n    .footer_head {\n      .logo {\n        img {\n          height: 18px;\n        }\n      }\n\n      .footer_content {\n        margin-top: 28px;\n        font-size: 14px;\n        color: #606a77;\n\n        .address {\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n\n          li {\n            position: relative;\n            display: flex;\n            align-items: center;\n\n            span {\n              display: flex;\n              align-items: center;\n              gap: 8px;\n\n              strong {\n                color: #9ea0a4;\n                font-weight: 400;\n              }\n\n              &.ceo {\n                strong {\n                  font-weight: 700;\n                  color: #9ea0a4;\n                }\n              }\n            }\n            span + span::before {\n              content: \"\";\n              display: block;\n              width: 1px;\n              height: 10px;\n              margin: 0 4px 0 12px;\n              background-color: #555b64;\n            }\n          }\n        }\n\n        .copyright {\n          margin-top: 20px;\n        }\n      }\n    }\n\n    .footer_body {\n      font-size: 15px;\n      color: #606a77;\n\n      ul {\n        display: flex;\n        align-items: center;\n        li {\n          display: flex;\n          align-items: center;\n          & + li::before {\n            content: \"\";\n            display: block;\n            width: 1px;\n            height: 12px;\n            margin: 0 12px;\n            background-color: #555b64;\n          }\n\n          &:hover,\n          &:focus {\n            color: #9ea0a4;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Scroll Top\n.scroll_top_area {\n  position: fixed;\n  bottom: 40px;\n  right: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid #333;\n  cursor: pointer;\n}\n\n.inner {\n  position: relative;\n  justify-content: flex-start;\n  max-width: 1160px;\n  width: 100%;\n  height: 100%;\n}\n\n.m_show {\n  display: none !important;\n}\n.m_hide {\n  display: inline !important;\n}\n\n// Home\n.section_area {\n  //회사소개\n  .section_intro {\n    display: flex;\n    justify-content: center;\n    height: 912px;\n    margin-top: 80px;\n    background-color: #d9dbde;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n\n    .inner {\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n    }\n\n    .section_head {\n      h1 {\n        font-size: 68px;\n        font-weight: 800;\n        line-height: 90px;\n      }\n      p {\n        margin-top: 33px;\n        font-size: 22px;\n        font-weight: 500;\n        line-height: 34px;\n      }\n    }\n    .section_body {\n      .character {\n        position: absolute;\n        top: 50%;\n        right: 0;\n        transform: translateY(-50%);\n        width: 626px;\n      }\n    }\n  }\n\n  // 서비스 01\n  .section_description {\n    display: flex;\n    justify-content: center;\n\n    .section_head {\n      width: 100%;\n      margin: 140px 0;\n\n      > div {\n        display: flex;\n        width: 100%;\n      }\n      h1 {\n        font-size: 76px;\n        font-weight: 700;\n        line-height: 100px;\n        letter-spacing: -0.02em;\n      }\n\n      p {\n        width: 72%;\n        margin-top: 84px;\n        margin-left: auto;\n        font-size: 44px;\n        font-weight: 600;\n        line-height: 64px;\n        letter-spacing: -0.02em;\n      }\n    }\n  }\n  // 서비스 02\n  .section_service {\n    display: flex;\n    justify-content: center;\n    padding: 200px 0;\n    color: #fff;\n    background-color: #0f1215;\n\n    .inner {\n      flex-direction: column;\n      align-items: flex-start;\n\n      .section_head {\n        .title_tag {\n          display: block;\n          font-size: 20px;\n          font-weight: 700;\n          margin-bottom: 10px;\n        }\n        h1 {\n          font-size: 52px;\n          font-weight: 700;\n          line-height: 62px;\n          letter-spacing: 0em;\n        }\n        ul {\n          margin-top: 26px;\n\n          li {\n            font-size: 20px;\n            font-weight: 500;\n            line-height: 28px;\n            color: #8d9fb0;\n          }\n        }\n      }\n\n      .section_body {\n        width: 100%;\n        margin-top: 80px;\n\n        .service_grid {\n          display: grid;\n          grid-template-columns: repeat(3, 1fr);\n          grid-template-rows: repeat(2, 1fr);\n          grid-column-gap: 30px;\n          grid-row-gap: 30px;\n\n          > div {\n            padding: 60px 50px 40px;\n            border-radius: 28px;\n            overflow: hidden;\n          }\n\n          > div:nth-child(1) {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            background: linear-gradient(270deg, #c229cb 0%, #5072dc 100%);\n            grid-area: 1 / 1 / 2 / 3;\n\n            h2 {\n              font-size: 36px;\n              font-weight: 700;\n              line-height: 44px;\n            }\n\n            p {\n              margin-top: 16px;\n              font-size: 20px;\n              font-weight: 700;\n              line-height: 34px;\n              opacity: 0.8;\n            }\n            span {\n              display: block;\n              margin-top: 74px;\n              font-size: 20px;\n              font-weight: 500;\n              line-height: 34px;\n              opacity: 0.5;\n            }\n          }\n          > div:nth-child(2) {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            background: #3f00f4;\n            grid-area: 1 / 3 / 2 / 4;\n          }\n          > div:nth-child(3) {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            background: #138dff;\n            grid-area: 2 / 1 / 3 / 2;\n          }\n          > div:nth-child(4) {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            background: linear-gradient(90deg, #3cd8b4 0%, #8244ee 100%);\n            grid-area: 2 / 2 / 3 / 4;\n\n            .grid_head {\n              display: flex;\n              flex-direction: column;\n              justify-content: space-between;\n              height: 100%;\n\n              h2 {\n                font-size: 36px;\n                font-weight: 700;\n                line-height: 44px;\n              }\n\n              ul {\n                display: flex;\n                gap: 38px;\n\n                li {\n                  h3 {\n                    font-size: 16px;\n                    font-weight: 700;\n                    letter-spacing: -0.05em;\n                  }\n                  p {\n                    margin-top: 6px;\n                    font-size: 32px;\n                    font-weight: 600;\n                    letter-spacing: -0.05em;\n\n                    span {\n                      font-weight: 800;\n                    }\n                  }\n                }\n              }\n            }\n\n            .grid_body {\n              margin-bottom: -64px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  //솔루션\n  .section_solution {\n    display: flex;\n    justify-content: center;\n    padding: 200px 0;\n\n    .section_head {\n      .title_tag {\n        display: block;\n        font-size: 20px;\n        font-weight: 700;\n        color: #027dff;\n        margin-bottom: 10px;\n      }\n      h1 {\n        font-size: 52px;\n        font-weight: 700;\n        line-height: 62px;\n      }\n      p {\n        margin-top: 26px;\n        font-size: 20px;\n        font-weight: 500;\n        line-height: 28px;\n      }\n    }\n\n    .section_body {\n      margin-top: 50px;\n\n      .solution_banner {\n        display: flex;\n        align-items: flex-end;\n        height: 624px;\n        padding: 90px 60px;\n        color: #fff;\n        background-size: contain;\n        background-repeat: no-repeat;\n\n        h1 {\n          font-size: 46px;\n          line-height: 68px;\n        }\n      }\n\n      .solution_banner_desc {\n        position: relative;\n        display: flex;\n        align-items: center;\n        height: 399px;\n        margin-top: 26px;\n        padding: 69px 60px;\n        border-radius: 40px;\n        background-color: #f3f4f8;\n        background-size: contain;\n        background-repeat: no-repeat;\n        overflow: hidden;\n\n        h1 {\n          font-size: 34px;\n          font-weight: 700;\n          line-height: 53px;\n          color: #2f4459;\n\n          p {\n            color: #138dff;\n\n            span {\n              font-weight: 400;\n            }\n          }\n        }\n\n        img {\n          position: absolute;\n          top: 0;\n          right: 0;\n          width: 518px;\n        }\n      }\n    }\n\n    + .banner {\n      text-align: center;\n    }\n  }\n\n  //비즈니스\n  .section_card_list {\n    display: flex;\n    justify-content: center;\n    padding: 240px 0;\n    background-color: #f5f6f9;\n\n    .section_head {\n      .title_tag {\n        display: block;\n        font-size: 20px;\n        font-weight: 700;\n        color: #8b93b5;\n        margin-bottom: 10px;\n      }\n      h1 {\n        font-size: 52px;\n        font-weight: 700;\n        line-height: 62px;\n        color: #0f1e2d;\n\n        span {\n          color: #0d96ff;\n        }\n      }\n      p {\n        margin-top: 26px;\n        font-size: 20px;\n        font-weight: 500;\n        line-height: 24px;\n        color: #0f1e2d;\n\n        span {\n          color: #9ca4ac;\n        }\n      }\n    }\n    .section_body {\n      margin-top: 70px;\n\n      .card_list {\n        display: grid;\n        grid-template-columns: repeat(4, 1fr);\n        grid-template-rows: 1fr;\n        grid-column-gap: 16px;\n        grid-row-gap: 0px;\n\n        > li {\n          flex: 1;\n\n          .card_cont {\n            display: flex;\n            flex-direction: column;\n\n            height: 343px;\n            padding: 44px 30px 30px;\n            border-radius: 30px;\n            background-color: #e6eaf3;\n\n            h2 {\n              display: flex;\n              align-items: center;\n              font-size: 24px;\n              font-weight: 700;\n              line-height: 30px;\n              letter-spacing: -0.05em;\n\n              span {\n                display: flex;\n                align-items: center;\n              }\n              span + span::before {\n                content: \"\";\n                display: block;\n                width: 7px;\n                height: 7px;\n                margin: 0 8px;\n                border-radius: 50%;\n                background-color: #122335;\n              }\n            }\n\n            ul {\n              display: flex;\n              flex-direction: column;\n              gap: 8px;\n              margin-top: 20px;\n              font-size: 17px;\n              font-weight: 500;\n            }\n\n            p {\n              margin-top: auto;\n              margin-left: auto;\n            }\n          }\n\n          .card_desc {\n            margin-top: 26px;\n            padding: 0 3px;\n            font-size: 20px;\n            font-weight: 600;\n            line-height: 31px;\n            letter-spacing: -0.05em;\n          }\n        }\n      }\n    }\n  }\n\n  .section_partner {\n    display: flex;\n    justify-content: center;\n    padding: 200px 0;\n\n    .inner {\n      .section_head {\n        h1 {\n          font-size: 52px;\n          font-weight: 700;\n          line-height: 66px;\n          color: #0f1e2d;\n          text-align: center;\n        }\n        .partner_count {\n          margin: 70px auto 115px;\n          ul {\n            display: flex;\n            justify-content: center;\n            gap: 100px;\n            li {\n              text-align: center;\n\n              p {\n                font-size: 56px;\n                font-weight: 600;\n                letter-spacing: -0.05em;\n\n                strong {\n                  font-weight: 800;\n                }\n              }\n\n              em {\n                display: block;\n                margin-top: 14px;\n                font-size: 18px;\n                font-weight: 700;\n                color: #0d96ff;\n              }\n            }\n          }\n        }\n      }\n\n      .section_body {\n        margin-top: 70px;\n      }\n    }\n  }\n\n  .section_company {\n    display: flex;\n    background-color: #f3f4f8;\n\n    .section_head {\n      text-align: right;\n    }\n    .section_body {\n      flex: 1;\n      display: flex;\n      align-items: flex-end;\n      padding: 103px 90px;\n      background-color: #f3f4f8;\n\n      ul {\n        display: flex;\n        flex-direction: column;\n        gap: 22px;\n\n        dl {\n          display: flex;\n          gap: 30px;\n          font-size: 19px;\n          color: #262626;\n          letter-spacing: -0.05em;\n\n          dt {\n            min-width: 83px;\n            font-weight: 700;\n          }\n\n          dd {\n            font-weight: 500;\n          }\n        }\n      }\n\n      .company_logo {\n        max-width: 373px;\n        padding-bottom: 8px;\n      }\n    }\n  }\n}\n\n@media (max-width: 1080px) {\n  .inner {\n    padding: 0 18px;\n  }\n  .m_show {\n    display: inline !important;\n  }\n  .m_hide {\n    display: none !important;\n  }\n\n  .header {\n    position: sticky;\n    top: -56px;\n\n    .inner {\n      flex-direction: column;\n      align-items: flex-start;\n      height: auto;\n      .logo {\n        padding: 11px 0;\n        img {\n          width: 120px;\n        }\n      }\n      .gnb {\n        width: 100%;\n        ul {\n          justify-content: space-between;\n          gap: unset;\n\n          li {\n            a {\n              padding: 14px 0;\n              font-size: 16px;\n              letter-spacing: -0.05em;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .footer {\n    .inner {\n      padding: 40px 20px;\n\n      .footer_content {\n        .address {\n          li:nth-child(2) {\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 8px;\n\n            span + span::before {\n              content: \"\";\n              display: none;\n            }\n          }\n        }\n\n        .copyright {\n          font-size: 13px;\n        }\n      }\n    }\n  }\n\n  .section_area {\n    // 회사소개\n    .section_intro {\n      height: 340px;\n      margin-top: 0px;\n      background-position: right -125px bottom -30px;\n\n      .inner {\n        align-items: flex-start;\n        padding-top: 44px;\n      }\n      .section_head {\n        h1 {\n          font-size: 26px;\n          line-height: 36px;\n        }\n\n        p {\n          margin-top: 15px;\n          font-size: 14px;\n          line-height: 22px;\n          letter-spacing: -0.05em;\n        }\n      }\n    }\n\n    // 서비스 01\n    .section_description {\n      .section_head {\n        margin: 60px 0;\n\n        h1 {\n          font-size: 26px;\n          line-height: 34px;\n        }\n        p {\n          margin-top: 20px;\n          font-size: 16px;\n          line-height: 24px;\n        }\n      }\n    }\n\n    // 서비스 02\n    .section_service {\n      padding: 80px 0;\n\n      .inner {\n        .section_head {\n          .title_tag {\n            font-size: 16px;\n          }\n          h1 {\n            font-size: 26px;\n            line-height: 34px;\n          }\n          ul {\n            margin-top: 12px;\n            li {\n              font-size: 14px;\n              line-height: 20px;\n            }\n          }\n        }\n\n        .section_body {\n          margin-top: 38px;\n\n          .service_grid {\n            grid-template-columns: repeat(2, 1fr);\n            grid-template-rows: repeat(3, 1fr);\n            grid-column-gap: 10px;\n            grid-row-gap: 20px;\n\n            > div {\n              padding: 20px 16px;\n            }\n\n            > div:nth-child(1) {\n              position: relative;\n              grid-area: 1/1/2/3;\n\n              h2 {\n                font-size: 20px;\n                line-height: 28px;\n              }\n              p {\n                margin-top: 10px;\n                font-size: 14px;\n                line-height: 17px;\n              }\n              span {\n                margin-top: 39px;\n                font-size: 13px;\n                line-height: 16px;\n              }\n\n              img {\n                position: absolute;\n                top: 50%;\n                right: 20px;\n                transform: translateY(-50%);\n                display: block;\n                width: 111px;\n                object-fit: contain;\n              }\n            }\n            > div:nth-child(2) {\n              grid-area: 2/1/3/2;\n              img {\n                width: 105px;\n              }\n            }\n            > div:nth-child(3) {\n              grid-area: 2/2/3/3;\n              img {\n                width: 130px;\n              }\n            }\n            > div:nth-child(4) {\n              position: relative;\n              grid-area: 3/1/4/3;\n\n              .grid_head {\n                h2 {\n                  font-size: 20px;\n                  line-height: 28px;\n                }\n\n                ul {\n                  gap: 12px;\n                  li {\n                    h3 {\n                      font-size: 13px;\n                      line-height: 16px;\n                      letter-spacing: 0;\n                    }\n                    p {\n                      font-size: 20px;\n                      line-height: 24px;\n                      letter-spacing: 0;\n                    }\n                  }\n                }\n              }\n\n              .grid_body {\n                img {\n                  position: absolute;\n                  bottom: 0;\n                  right: 8px;\n                  display: block;\n                  width: 106px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // 솔루션\n    .section_solution {\n      padding: 60px 0;\n\n      .section_head {\n        .title_tag {\n          font-size: 16px;\n        }\n        h1 {\n          font-size: 26px;\n          line-height: 34px;\n        }\n        p {\n          margin-top: 12px;\n          font-size: 14px;\n          line-height: 20px;\n        }\n      }\n\n      .section_body {\n        .solution_banner {\n          height: 240px;\n          padding: 20px 30px;\n          border-radius: 18px;\n          background-size: cover;\n          background-position: center;\n          overflow: hidden;\n\n          h1 {\n            font-size: 18px;\n            line-height: 26px;\n          }\n        }\n\n        .solution_banner_desc {\n          height: auto;\n          margin-top: 16px;\n          padding: 22px 20px;\n          border-radius: 18px;\n\n          h1 {\n            position: relative;\n            padding-top: 236px;\n            font-size: 18px;\n            line-height: 28px;\n            z-index: 1;\n          }\n\n          p {\n            display: inline;\n          }\n        }\n      }\n\n      + .banner {\n        height: 165px;\n        img {\n          height: 100%;\n          object-fit: cover;\n        }\n      }\n    }\n\n    // 비즈니스\n    .section_card_list {\n      padding: 60px 0;\n\n      .section_head {\n        .title_tag {\n          font-size: 16px;\n        }\n\n        h1 {\n          font-size: 26px;\n          line-height: 36px;\n        }\n\n        p {\n          margin-top: 12px;\n          font-size: 14px;\n          line-height: 22px;\n        }\n      }\n      .section_body {\n        margin-top: 30px;\n\n        .card_list {\n          display: flex;\n          flex-direction: column;\n          gap: 30px;\n\n          > li {\n            .card_cont {\n              display: grid;\n              grid-template-columns: 4fr 3fr;\n              grid-template-rows: repeat(2, 1fr);\n              height: 130px;\n              padding: 20px 30px;\n\n              h2 {\n                grid-area: 1/1/2/2;\n                font-size: 16px;\n              }\n              ul {\n                grid-area: 2/1/3/2;\n                gap: 5px;\n                margin-top: 0;\n                font-size: 13px;\n                line-height: 15px;\n              }\n              p {\n                grid-area: 1/2/3/3;\n                margin: auto;\n\n                img {\n                  width: 80px;\n                }\n              }\n            }\n\n            .card_desc {\n              margin-top: 14px;\n              font-size: 14px;\n              line-height: 22px;\n            }\n          }\n        }\n      }\n    }\n\n    .section_partner {\n      padding: 60px 0;\n\n      .inner {\n        .section_head {\n          h1 {\n            font-size: 26px;\n            line-height: 36px;\n          }\n        }\n\n        .section_body {\n          margin-top: 40px;\n\n          .img_partner {\n            padding: 0 20px;\n          }\n        }\n      }\n    }\n    .section_company {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
